
export interface AppState {
    showSpinner?:boolean
    countryIcon: string;
    progressBar:boolean;
    // translations?: { [key: string]: any };
    languageTemplateUrl?: string;
}

export const initialState: AppState = {
    showSpinner : false,
    countryIcon: null,
    progressBar: false,
    // translations: {},
    languageTemplateUrl: null,
};